import { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {
  OreDistributorButton,
  OreDistributorListItem,
  OreStack,
  OreText,
  SvgDownload,
  SvgExcel
} from '@edenredespana/oreneta'
import { DropZone, UploadingModal } from '@/Shared/ui/DropZone'
import { useExcelUpload } from '@/Store/ui/context/ExcelUploadContext'
import { ExcelLayout } from '@/Store/ui/templates/ExcelLayout'
import { CancelModal, ExcelUploaderInfo } from '@/Store/ui/molecules'
import { storesTranslation } from '@/Store/ui/storesTranslation'
import { handleErrors } from '@/Shared/ui/form'
import { navigationRoutes } from '@/Shared/ui/routers/data/navigationRoutes'
import { useNavigate } from 'react-router-dom'

export const ExcelUploader = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(!open);

  const {
    uploadForm: { formState, handleSubmit, register, watch, clearErrors },
    validFileFormats,
    uploading,
    upload,
    download,
    hasWrongFormatError,
    setHasWrongFormatError,
    setError,
    setDisplayCancelModal,
  } = useExcelUpload()
  const { errors } = handleErrors(formState)

  const fileField = watch('file')

  useEffect(() => {
    if (fileField) {
      setHasWrongFormatError(false)
      clearErrors()
      setError(undefined)
    }
  }, [fileField])

  return (
    <ExcelLayout
      onCancel={() => setDisplayCancelModal(true)}
      onContinue={handleSubmit(upload)}
      continueDisabled={fileField !== undefined && (!formState.isValid || hasWrongFormatError)}>
      <OreStack direction="column" space="medium" placeItems="start">
        <ExcelUploaderInfo />
      </OreStack>
      <OreStack
        direction="column"
        space="medium"
        placeItems="start"
        placeContent="start"
        style={{
          maxWidth: '300px',
          position: 'relative'
        }}

      >
        <OreDistributorButton
          category="secondary"
          open={open}
          handleClick={handleClick}
          label={t(storesTranslation.excelTpvUpload.downloadButton)}
          icon={<span style={{ paddingRight: '8px' }}><SvgDownload /></span>}
        >
          <OreDistributorListItem
            title={t(storesTranslation.excelTpvUpload.downloadEmpty)}
            handleClick={async () => {
              await download(true)
              setOpen(false)
            }
            }
            icon={<SvgExcel />}
          />
          <OreDistributorListItem
            title={t(storesTranslation.excelTpvUpload.downloadPreloaded)}
            handleClick={async () => {
              await download(false)
              setOpen(false)
            }}
            icon={<SvgExcel />}
          />
        </OreDistributorButton>
      </OreStack>
      <DropZone
        {...register('file')}
        {...errors('file')}
        validFileFormats={validFileFormats}
        allowCSV={false}
      />
      <OreText>
        <Trans
          t={t}
          components={[
            <span style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => navigate(navigationRoutes.newTicket, { state: { caseReasonId: 16 } })} />,
          ]}
        >
          {t(storesTranslation.excelTpvUpload.legend)}
        </Trans>
      </OreText>
      <CancelModal />
      <UploadingModal uploading={uploading} />
    </ExcelLayout>
  )
}
